import { NIMASA_AGENT_MUTATION_TYPES } from "../../mutation-types";

/**
 * NIMASA Agent mutations
 */

const mutations = {
  /**
   * Save the shipping requests awaiting processing
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_SHIPPING_REQUESTS_AWAITING_PROCESSING](
    state,
    shippingRequests
  ) {
    state.shippingRequestsAwaitingProcessing = shippingRequests;
  },

  /**
   * Save the shipping requests pending approval
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_SHIPPING_REQUESTS_PENDING_APPROVAL](
    state,
    shippingRequests
  ) {
    state.shippingRequestsPendingApproval = shippingRequests;
  },
  /**
   * Save the shipping requests APROVED
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_SHIPPING_REQUESTS_APPROVED_APPLICATIONS](
    state,
    shippingRequests
  ) {
    state.shippingRequestsApproved = shippingRequests;
  },
  /**
   * Save the shipping requests DISAPPROVED
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_SHIPPING_REQUESTS_DISAPPROVED_APPLICATIONS](
    state,
    shippingRequests
  ) {
    state.shippingRequestsDisapproved = shippingRequests;
  },
  /**
   * Save the shipping requests FAILED_PROCESSING
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_SHIPPING_REQUESTS_FAILED_PROCESSING](
    state,
    shippingRequests
  ) {
    state.shippingRequestsFailedProcessing = shippingRequests;
  },

  /**
   * Save the search results for nimasa
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_NIMASA_SEARCH_RESULTS](
    state,
    shippingRequests
  ) {
    state.searchResults = shippingRequests;
  },
  /**
   * Save all the shipping applications on the app
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_ALL_SHIPPING_APPLICATIONS](
    state,
    shippingRequests
  ) {
    state.allShippingApplications = shippingRequests;
  },
  /**
   * Save the ports berthed shipments 
   * @param {*} state
   * @param {*} shippingRequests
   */
  [NIMASA_AGENT_MUTATION_TYPES.SAVE_PORTS_BERTHED_APPLICATIONS](
    state,
    shippingRequests
  ) {
    state.portsBerthedApplications = shippingRequests;
  }
};

export default mutations;
